import { render, staticRenderFns } from "./MoleculeEditionAssetSignedStudentsInvitations.vue?vue&type=template&id=6f54437d&"
import script from "./MoleculeEditionAssetSignedStudentsInvitations.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAssetSignedStudentsInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports